import React, { useRef } from "react";
import CountUp from "react-countup";
import { useInView } from "framer-motion";

export const StatCounter = ({ value, prefix = "", suffix = "", label, dark = true, separator = ",", testId }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const prefersReduced = typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const numColor = dark ? "text-white" : "text-navy";
  const labelColor = dark ? "text-white/70" : "text-secondary-ssa";
  const staticValue = separator ? value.toLocaleString() : String(value);

  return (
    <div ref={ref} data-testid={testId} className="flex flex-col">
      <span className={`font-display font-semibold text-3xl sm:text-4xl lg:text-5xl ${numColor}`}>
        {prefix}
        {inView && !prefersReduced ? (
          <CountUp end={value} duration={1.6} separator={separator} />
        ) : (
          staticValue
        )}
        {suffix}
      </span>
      <span className={`mt-2 text-xs sm:text-sm tracking-wide ${labelColor}`}>{label}</span>
    </div>
  );
};
